import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPixverseAiVideoGeneratorConfig } from '@/data/landingConfig/landingPixverseAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PixverseAiVideoGenerator } from './schemaObject';

interface Props {}
const PixverseAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PixverseAiVideoGenerator} />
			<LandingTemplate
				data={landingPixverseAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default PixverseAiVideoGenerator;
